// extracted by mini-css-extract-plugin
export default {"mainDiv":"AboutPage_mainDiv__PWyIl","yellowSpan":"AboutPage_yellowSpan__14iZA","whiteSpan":"AboutPage_whiteSpan__SgRbe"};